export const SET_ESTATE_PAGE_DATA = 'ksk001/estatePage/SET_ESTATE_PAGE_DATA'

export const initialState = {
  estateData: null,
}

export default (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case SET_ESTATE_PAGE_DATA:
      return {
        ...state,
        estateData: payload,
      }
    default:
      return state
  }
}

export const setEstateData = data => dispatch => {
  dispatch({
    type: SET_ESTATE_PAGE_DATA,
    payload: data,
  })
}
